module.exports = __webpack_public_path__ + "img/shuicao.c5980d58.png";